import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TableActionButton } from "src/app/modules/competition/enums/enums";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { JobsSortBy, sortDirections } from "../../../modules/jobs/enums/enums";
import { ConfirmModalService } from "../../confirm-modal/confirm-modal.service";

@Component({
  selector: "list-table",
  templateUrl: "./list-table.component.html",
  styleUrls: ["./list-table.component.scss"],
})
export class ListTableComponent implements OnInit, OnDestroy {
  translationModulesEnum = TranslationModuleEnum;

  private endSub$ = new Subject();

  lang: string = this.translate.currentLang;
  @Output() action = new EventEmitter<{ actionType: string; row: any }>();
  public sortedCol: any = null;
  public sortDirection: sortDirections = sortDirections.Asc;
  @Input() sortKey;
  @Input() public set SortedCol(val: JobsSortBy | null) {
    this.sortedCol = val;
  }
  @Input() public set SortDirection(val: sortDirections | null) {
    this.sortDirection = val;
  }
  @Input() list = [];
  @Input() columns = [];
  @Input() link: string;
  @Input() isLink: boolean = true;

  @Input() totalItems: number;
  @Input() paginationModel: any = {
    pageIndex: 1,
    pageSize: 10,
  };

  @Input() autoHidePagination = false;

  @Output() sortFilter = new EventEmitter();
  @Output() onPaginateEvent = new EventEmitter();
  @Input() modEnum: string;
  @Output() selectedRowsChange = new EventEmitter<any[]>();
  @Input() selectedRows: any[] = [];
  @Input() showCheckBoxes: boolean = false;
  @Input() hasPagination: boolean = true;
  @Input() isTableSortable: boolean = true;
  @Input() showTableHeader: boolean = true;
  itemsPerPageList: {id:number, value:number}[] = [
    {id:1, value: 10 },
    {id:2, value: 25 },
    {id:3, value: 50 },
    {id:4, value: 75 },
    {id:5, value: 100 },
  ];
  @Input() itemsPerPage: number = 10;
  @Output() itemsPerPageChange = new EventEmitter<number>();

  
  onItemsPerPageChanged(newValue: number) {
    this.itemsPerPage = newValue;
    this.itemsPerPageChange.emit(this.itemsPerPage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedRows"] && changes["selectedRows"].currentValue) {
      console.log("changing");

      const newSelectedRows = changes["selectedRows"].currentValue;
      if (Array.isArray(newSelectedRows) && newSelectedRows.length === 0) {
        this.resetSelectedRows();
      }
    }
  }
  onRowSelect(row) {
    if (row.selected) {
      this.selectedRows.push(row);
    } else {
      const index = this.selectedRows.findIndex(r => r.id === row.id);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }
  resetSelectedRows() {
    this.selectedRows = [];
    this.list.forEach(item => {
      item.selected = false;
    });
    this.selectedRowsChange.emit(this.selectedRows);
  }
  isAllSelected() {
    return this.list.every(item => item.selected);
  }
  toggleAllRows(event) {
    const isChecked = event.target.checked;
    this.list.forEach(item => {
      item.selected = isChecked;
      if (isChecked) {
        if (!this.selectedRows.includes(item)) {
          this.selectedRows.push(item);
        }
      } else {
        this.selectedRows = [];
      }
    });
    this.selectedRowsChange.emit(this.selectedRows);
  }

  constructor(
    private translate: TranslateService,
    private confirmationPopupService: ConfirmModalService
  ) {}

  ngOnInit(): void {
    // handles language change event
    this.handleLangChange();
    console.log(this.list);
  }
  ngOnDestroy() {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
  // if there is a table contains action buttons this functino tells parent component
  // which action to take dynamically
  handleAction(actionType: string, row: any): void {
    this.action.emit({ actionType, row });
  }
  // handles language change event
  handleLangChange() {
    this.translate.onLangChange.pipe(takeUntil(this.endSub$)).subscribe(() => {
      this.lang = this.translate.currentLang;
    });
  }

  // emit a pagination event to the parent component
  onPaginate(e) {
    this.onPaginateEvent.emit(e);
  }

  // sort items by column
  sort(col) {
    if (this.sortedCol === col) {
      if (this.sortDirection === sortDirections.Asc) {
        this.sortDirection = sortDirections.Desc;
      } else {
        this.sortDirection = sortDirections.Asc;
      }
    } else {
      this.sortDirection = sortDirections.Asc;
    }

    this.sortedCol = col;
    this.sortFilter.emit({
      sortDirection: this.sortDirection,
      sortKey: this.sortedCol,
    });
  }

  public get ascMode(): boolean {
    return this.sortDirection === sortDirections.Asc;
  }

  public get descMode(): boolean {
    return this.sortDirection === sortDirections.Desc;
  }
  shouldShowButton(button: TableActionButton, row: any): boolean {
    if (!button.permissionCheck) {
      return true;
    }

    return (
      (row.actions && row.actions[button.permissionCheck] === true) ||
      row[button.permissionCheck] === true || 
      (row.permissions && row.permissions[button.permissionCheck] === true)
    );
  }
}

/* This is how actions buttons should look like

  // {
  //   key: "",
  //   columnLabel: "membership.members.paymentInfoActions",
  //   type: "actions",
  //   buttons: [
  //     {
  //       label: "",
  //       className: "btn btn-main",
  //       actionType: "preview",
  //       modEnum: this.translationModulesEnum.membership,
  //     },
  //     {
  //       label: "",
  //       actionType: "downloadInvoice",
  //       // the action type of which the component will decide which action function to fire comming from the list-table component dynamically
  //       className: "btn btn-success",
  //       modEnum: this.translationModulesEnum.membership,
  //     },
  //   ],
  // },

  */
